import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import { nemiPayTranslation } from './locales/nemiPay';
import { companyHost } from '@/const/companyHost';
Vue.use(VueI18n);

const translationsMessage = JSON.parse(window.localStorage.getItem('translations') || '{}');

let messages = nemiPayTranslation as LocaleMessages;

if (Object.keys(translationsMessage).length === 0) {
  messages[companyHost] = {
    menu: nemiPayTranslation.nemiPay.menu,
    commerce: nemiPayTranslation.nemiPay.commerce,
    company: nemiPayTranslation.nemiPay.company,
    myProfile: nemiPayTranslation.nemiPay.myProfile,
    commpixDetails: nemiPayTranslation.nemiPay.commpixDetails,
  };
} else {
  messages = translationsMessage;
}

export default new VueI18n({
  locale: companyHost,
  fallbackLocale: 'nemiPay',
  silentFallbackWarn: true,
  messages,
});
